import React from 'react';
import { motion } from 'framer-motion';
import { reveal } from '../utils/motion';
import { CaseStudyCard } from '../components/CaseStudyCard';
import { SiteHeader } from '../components/SiteHeader';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { caseStudies, heroMetrics } from '../data/caseStudies';
import { clientLogos } from '../data/clientLogos';
import { linkClass } from '../utils/linkClass';
export function Home() {
  return <div className="min-h-screen w-full bg-white font-sans text-ink" data-id="element-116" data-mp="24h0qy1bdf38x">
      <div className="mx-auto flex max-w-[1347px] flex-col gap-[30px] px-5 py-10 md:px-10" data-id="element-117" data-mp="24hag5mold6dk">
        <SiteHeader data-id="element-118" data-mp="29ek6d4jt1m2g" />

        <main className="flex flex-col gap-[30px]" data-id="element-119" data-mp="29ihqnti4cjnx">
          <section className="flex flex-col-reverse gap-6 min-[700px]:flex-row min-[700px]:items-center min-[700px]:gap-[60px] py-10 md:py-20" data-id="element-120" data-mp="2dirsctyvonwz">
            <div className="flex flex-1 flex-col justify-end gap-5" data-id="element-121" data-mp="3kxmtcxi92i7j">
              <motion.div className="flex flex-col gap-3" initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={reveal} data-id="element-122" data-mp="3ovar08bbup34">
                <h1 className="text-headline font-semibold" data-id="element-123" data-mp="2vyhss2iroqsc">
                  18 years of experience across B2B SaaS, fintech, and healthcare.
                </h1>
                <p className="text-subhead text-muted" data-id="element-124" data-mp="2mxs3zirxc0o4">
                  Specialize in driving business results through improved usability.
                </p>
              </motion.div>
            </div>
            <motion.img src="https://cdn.magicpatterns.com/uploads/oThdsUnkXC7FRqpUL19do3/Meikson-Square.jpg" alt="Portrait of Michael Meikson" className="aspect-square w-[160px] shrink-0 rounded-full object-cover min-[700px]:w-[200px]" initial={{
            opacity: 0,
            x: 60
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            ...reveal,
            delay: 0.05
          }} data-id="element-125" data-mp="2d65sdlbobzku" />
          </section>

          <motion.section aria-label="Clients" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          ...reveal,
          delay: 0.15
        }} data-id="element-126" data-mp="1kkqmfd8pqadf">
            <ul className="grid grid-cols-3 items-center gap-x-4 gap-y-2 md:grid-cols-6" data-id="element-127" data-mp="1amj8z4dmuag6">
              {clientLogos.map(logo => <li key={logo.name} className="flex items-center justify-center" data-id="element-128" data-mp="1fkuljmvbaz23">
                  <img src={logo.src} alt={logo.name} className="block aspect-[2/1] w-full max-w-[200px] object-contain" data-id="element-129" data-mp="23aouvugfa5hl" />
                </li>)}
            </ul>
          </motion.section>

          <ul aria-label="Results" className="grid w-full grid-cols-1 gap-[30px] sm:grid-cols-3" data-id="element-130" data-mp="1tlx7lzmb49d0">
            {heroMetrics.map((m, i) => <motion.li key={m.label} className="flex flex-col rounded-[30px] bg-positive-bg p-5 [container-type:inline-size]" initial={{
            opacity: 0,
            y: 24
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            ...reveal,
            delay: 0.3 + i * 0.06
          }} data-id="element-131" data-mp="1yix9rzg1cryu" data-mpi={i}>
                <span className="whitespace-nowrap text-[clamp(22px,21cqw,40px)] font-normal leading-[1.35] tracking-[-0.02em] text-positive" data-id="element-132" data-mp="amqz5pc90ad0">
                  {m.value}
                </span>
                <span className="text-xl leading-[27px] tracking-[-0.02em]" data-id="element-133" data-mp="kcisyhciwzgf">{m.label}</span>
              </motion.li>)}
          </ul>

          <section aria-label="Case studies" className="flex flex-col gap-[30px]" data-id="element-134" data-mp="3st58fazknw52">
            {caseStudies.map(study => <CaseStudyCard key={study.id} study={study} animate data-id="element-135" data-mp="3nv3sv01cueyc" />)}
          </section>

          <section className="flex flex-col gap-[30px] pt-2" data-id="element-136" data-mp="5ljn3e32op0j">
            <div className="flex flex-col gap-3" data-id="element-137" data-mp="ni38qxtolo0">
              <h2 className="text-headline font-semibold" data-id="element-138" data-mp="qw600aeewvz">
                AI has become the core of my design practice.
              </h2>
              <p className="text-subhead text-muted" data-id="element-139" data-mp="1c4hz1wjdpims">
                I prototype in code and can ship working software.
              </p>
            </div>
            <div className="grid grid-cols-1 gap-[30px] md:grid-cols-[minmax(0,1fr)_minmax(0,2fr)]" data-id="element-140" data-mp="27g9cvuj5f3on">
              <div className="flex flex-col gap-10" data-id="element-141" data-mp="2ceswvpe6m5ed">
              <div className="flex flex-col gap-4 text-base leading-[1.6]" data-id="element-142" data-mp="2hb9nqrcrmxv5">
                <p data-id="element-143" data-mp="2mbfjaim5p4ii">
                  My primary design tool is Magic Patterns, where I maintain working prototypes of client projects. 
                </p>
                <a href="https://project-unified-inbox-with-filtering-117.magicpatterns.app/" target="_blank" rel="noopener noreferrer" className={`w-fit text-base ${linkClass}`} data-id="element-144" data-mp="2qao95ce2si8s">
                  View RSI Prototype →
                </a>
              </div>
              <div className="flex flex-col gap-4 text-base leading-[1.6]" data-id="element-145" data-mp="3a1jcdw1pxlv9">
                <p data-id="element-146" data-mp="3e223fnvsenwe">
                  I built Percelo, an AEO (Answer Engine Optimization), tool solo in about two weeks with Claude Code. 
                </p>
                <a href="https://www.percelo.com" target="_blank" rel="noopener noreferrer" className={`w-fit text-base ${linkClass}`} data-id="element-147" data-mp="12gb5kiotcmvh">
                  Try Percelo →
                </a>
              </div>
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/8x9mJt8jkvyUyDgp9GG3CK/Percelo-hero2.png" alt="Percelo AI visibility report open on a laptop" className="h-[325px] w-full self-start rounded-[30px] object-cover object-[50%_45%]" data-id="element-148" data-mp="ohjrgw9yb17c" />
            </div>
          </section>

          <TestimonialsSection data-id="element-149" data-mp="17euqcfro7sm9" />
        </main>

        <div className="pt-10" data-id="element-150" data-mp="17byrmp800zwr">
          <SiteHeader as="footer" data-id="element-151" data-mp="24t71n7wsrc6z" />
        </div>
      </div>
    </div>;
}